import React, {useEffect} from 'react';
import {ChevronDown, ChevronUp} from 'lucide-react';

const MonthSelector = ({selectedMonth, onMonthChange, isOpen, setIsOpen}) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-based
  const currentYear = currentDate.getFullYear();

  // Generate last 12 months
  const generateMonths = () => {
    const months = [];
    let month = currentMonth;
    let year = currentYear;
    for (let i = 0; i < 12; i++) {
      const formattedMonth = month < 10 ? `0${month}` : month;
      months.push({
        value: `${year}-${formattedMonth}`,
        label: `Tháng ${month}/${year}`,
        isCurrentMonth: i === 0
      });

      month--;
      if (month === 0) {
        month = 12;
        year--;
      }
    }
    return months;
  };

  const months = generateMonths();

  const formatSelectedMonth = (monthValue) => {
    const month = months.find(m => m.value === monthValue);
    if (month?.isCurrentMonth) {
      return 'Tháng này';
    }
    return month?.label || 'Tháng này';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.month-selector')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, setIsOpen]);

  return (
    <div className="relative month-selector">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 hover:bg-gray-50 py-1 rounded-lg"
      >
        <span>{formatSelectedMonth(selectedMonth)}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500"/> :
          <ChevronDown className="w-5 h-5 text-gray-500"/>}
      </button>

      {isOpen && (
        <div
          className="absolute right-0 mt-1 bg-white border rounded-lg shadow-lg py-1 z-10 w-44 max-h-80 overflow-y-auto">
          {months.map((month) => (
            <button
              key={month.value}
              className={`w-full text-left px-4 py-2 hover:bg-gray-50 ${
                selectedMonth === month.value ? 'text-green-600 bg-green-50' : ''
              }`}
              onClick={() => {
                onMonthChange(month.value);
                setIsOpen(false);
              }}
            >
              {month.isCurrentMonth ? 'Tháng này' : month.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
export default MonthSelector;